import { store } from 'src/app/store';
import { selectCurrentPointId, getSelectPoint } from 'src/state';
import { playAudio, fadeOutAudio } from './audioUtils';

export function createPointAudio(audioContext: AudioContext) {
  const gainNodeOne = audioContext.createGain();
  const gainNodeTwo = audioContext.createGain();
  gainNodeOne.connect(audioContext.destination);
  gainNodeTwo.connect(audioContext.destination);

  let currentPointId: string | null | undefined;
  let currentGainNode = gainNodeOne;

  function onStateChange() {
    const state = store.getState();
    const newPointId = selectCurrentPointId(state);

    if (currentPointId !== newPointId) {
      const previousGainNode = currentGainNode;
      const previousPointId = currentPointId;

      currentGainNode = currentGainNode === gainNodeTwo ? gainNodeOne : gainNodeTwo;
      currentPointId = newPointId;

      if (previousPointId) {
        const previousPoint = getSelectPoint(previousPointId)(state);
        fadeOutAudio(previousPoint, audioContext, state, previousGainNode);
      }

      if (currentPointId) {
        const currentPoint = getSelectPoint(currentPointId)(state);
        playAudio(currentPoint, audioContext, state, currentGainNode, !previousPointId);
      }

    }
  }

  store.subscribe(onStateChange);
  onStateChange();
}
